import React from 'react';
import { useOrganization } from '@/hooks';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Select } from 'antd';

const { useFormInstance, useWatch } = Form;

export const Organization: React.FC = () => {
	const form = useFormInstance();
	const { setFieldValue } = useFormInstance();

	const {
		organizations: { data: organizations }
	} = useOrganization();

	const organizationId = useWatch('searching_organization_id', form);

	function handleOrganizationSelect(id: string) {
		setFieldValue(['searching_organization_id'], id);
		setFieldValue(['company_id_filter'], undefined);
		setFieldValue(['sector_id'], undefined);
		setFieldValue(['line_id'], undefined);
		setFieldValue(['workstation_id'], undefined);
		setFieldValue(['file_id'], undefined);
	}

	function handleClearOrganization() {
		setFieldValue(['searching_organization_id'], undefined);
		setFieldValue(['company_id_filter'], undefined);
		setFieldValue(['sector_id'], undefined);
		setFieldValue(['line_id'], undefined);
		setFieldValue(['workstation_id'], undefined);
		setFieldValue(['file_id'], undefined);
	}
	return (
		<Col xs={24}>
			<Form.Item labelCol={{ span: 24 }} name={['searching_organization_id']} label={I18n.get('Company')}>
				<Select
					showSearch
					allowClear
					value={organizationId ?? null}
					onClear={handleClearOrganization}
					onChange={handleOrganizationSelect}
					filterOption={(input, option) => (option?.label ?? '').includes(input)}
					disabled={organizations.length === 0}
					placeholder={I18n.get('Company')}
					options={organizations.map(({ id, name }) => ({ label: name, value: id }))}
				/>
			</Form.Item>
		</Col>
	);
};
